<template>
  <v-container>
    <v-row align="center">
      <v-spacer class="hidden-sm-and-down" />

      <v-col cols="12" md="auto">
        <div class="text-body-1 font-weight-light pt-6 pt-md-0 text-center">
          &copy; {{ new Date().getFullYear() }} {{ companyName }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import variableMixin from "@/mixins/variableMixin";

export default {
  name: "Links",
  mixins: [variableMixin],

  data: () => ({
    links: [
      {
        href: "https://vuetifyjs.com/",
        text: "Vuetify Docs"
      },
      {
        href: "#",
        text: "About Us"
      },
      {
        href: "#",
        text: "Blog"
      },
      {
        href: "#",
        text: "Licenses"
      }
    ]
  })
};
</script>

<style lang="sass" scoped>
a
  color: inherit !important
</style>
